// import { actions as accountActions } from ' redux/modules/account'
import AuthService from "services/auth"
import axios from "axios"
import store from "store"
import { actions as accountActions } from "modules/account"
import { actions as processActions } from "modules/process"
import { sendEmailOnLogout } from "services/public"
import { getConfig } from "utils/config"
import { getSubdomainFromUrl } from "utils/productUtils"
import debounce from "lodash.debounce"
import { isHiringManager } from "utils/utils"

// NOTE: This function is debounced to avoid multiple logout flows firing.
//       - Be aware: debounce introduces implicit state -- multiple calls within 1s will be ignored.
//       - Mixing side effects (sending email, clearing auth info, dispatching Redux actions, triggering navigation)
//         in one function couples unrelated concerns -- refactor for better maintainability.
const clearAuth = debounce(
  async () => {
    const env = process.env.REACT_APP_API_ENV
    if (getConfig(env).level !== "LOCAL") {
      // Get current user and organization info before clearing auth
      const state = store.getState()
      if (isHiringManager(state.user)) {
        const clientName =
          state.data?.organization?.name ||
          getSubdomainFromUrl() ||
          "Unknown Client"
        const currentPath = window.location.href

        // Send logout email notification
        try {
          await sendEmailOnLogout(state.user.email, clientName, currentPath)
          console.log("Logout email sent successfully")
        } catch (err) {
          console.log("Failed to send logout email:", err)
        }
      }
    }

    AuthService.clearAuthInfo()
    setTimeout(() => {
      store.dispatch(accountActions.logout())
    }, 100)
  },
  1000,
  { leading: true, trailing: false }
)

const checkTokenActions = (error, resolve, reject) => {
  let objToReplay = {
    initialRequest: error.config,
    resolve: resolve,
    reject: reject,
  }

  AuthService.pushToQueue(objToReplay)

  if (!AuthService.firstTimeFail) {
    AuthService.firstTimeFail = true
    AuthService.refreshToken()
      .then(res => {
        if (res && res.data) {
          AuthService.setAuthInfo(res.data)
          return AuthService.replayQueuedRequests()
        } else {
        }
      })
      .catch(err => {
        reject(err)
        //Failed even after refreshing token
        clearAuth()
      })
  }
}

// Handle API request errors
axios.interceptors.response.use(
  response => {
    AuthService.updateAuth()
    return response
  },
  error => {
    return new Promise((resolve, reject) => {
      if (error && !error.response) {
        //got an error but the error has no response
        clearAuth()
      } else if (
        error.response.status === 401 &&
        error.response.data &&
        error.response.data.error_description ===
          "Cannot convert access token to JSON"
      ) {
        //Specific error around access tokens
        clearAuth()
      } else if (
        error.response.status === 401 &&
        AuthService.isSavedTokenExpired()
      ) {
        checkTokenActions(error, resolve, reject)
      } else if (error.response.status === 401) {
        if (!AuthService.loggedIn()) {
          store.dispatch(
            processActions.processFailure({
              type: "login",
              message: error,
            })
          )

          reject(error)
        }
      } else {
        if (error.config.clearCredentialsOnError) {
          //error after refresh token
          clearAuth()
        }

        reject(error)
      }
    })
  }
)
